import { isEnabledMsg, isUnreadMsg } from "@/utils.js";
import { HeaderMenuBlock } from '../Block/HeaderMenuBlock/HeaderMenuBlock'
import { appNotification } from '@/components/AppNotification.js'
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { interval } from '@/components/Interval.js';
import { workplaceTypes } from "../types";
import { ModalContainerStaffSettings } from "../Modal/ModalContainerStaffSettings";
import { VehicleNumberBlock } from "../Block/VehicleNumberBlock";
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';
import { flightMenuBlock } from '@/Block/FlightMenuBlock.js';

export function print_staff(data, PV= 'В', settingBlock) {
    return [
        m(".row[style='text-align: left;margin: 0;']", [
            settingBlock == 'tgo' ? "Операции ТГО:" : [
                settingBlock == 'skill' ? "Навыки:" : []
            ]
        ]),
        data.length == 0 ? [ m(".row[style='text-align: center;margin: 20px 0px;color: darkgray;']", "<нет данных для отображения>" )] :
        [
            m(".row", [
            m(".col-xs-12", [
                data.map(function (title) {
                    return [
                        m("p", {
                            className: PV == 'В' ? "bg-danger" : "bg-info"
                        }, [
                            m("span", title.key),
                            m("ul", [
                                title.value.map(function (st) {
                                    return m("li[style='font-weight: 100']", [
                                        m("span", st.fio),
                                        st.confirm == 1 ?
                                            [
                                                m("span", " "),
                                                m("i.fa.fa-solid.fa-check[style='color: #5cb85c;']")
                                            ] : []
                                    ])
                                })
                            ])
                        ])
                    ]
                })
            ])
        ])
        ]
    ];
}

export var StaffOnFlightPage = {
    controller: function () {
        var self = this;
        var im;

        if (!user.exists()) {
            m.route('/login');
            return;
        }

        interval.clearAll();

        loader.show();

        if (user.get('state.workplace') === workplaceTypes.driver) {
            this.topMenu = [
                { title: 'Задачи', url: '/vehicle/tasks', icon: 'fa-tasks' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];

            if (user.get('state.vehicleFreeTasksAvailable')) {
                this.topMenu.unshift(
                    { title: 'Свободные', url: '/vehicle/tasks/free', icon: 'fa-car' }
                )
            }
        } else if (user.get('state.workplace') === workplaceTypes.agent) {
            this.topMenu = [
                { title: 'Задачи', url: '/agent/tasks', icon: 'fa-tasks' },
                { title: 'Рейсы', url: '/agent/flights', icon: 'fa-plane' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];
        } else {
            this.topMenu = [
                { title: 'Задачи', url: '/', icon: 'fa-tasks' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];
        }
////////////////////////////////////////////////////////////////////////////////////////
        this.data = m.request({
            method: 'GET',
            url: '/api/task/' + m.route.param('taskId') + '/staff'
        }).then(function (response) {
            server.setOnline();

            storage.config = response.config;

            appNotification.list = response.notifications;

            server.initPing();
            appNotification.init();

            if(localStorage.getItem("settingBlock")) {
                response.settingBlock = localStorage.getItem("settingBlock");
            }
            else {
                localStorage.setItem("settingBlock", "tgo");
                response.settingBlock = "tgo";
            }

            let block_list = JSON.parse(localStorage.getItem(response.settingBlock));
            var staff = [];
            if(block_list) {
                for (let i = 0; i < block_list.length; i++) {
                    if (block_list[i].check) {
                        var tgo = [], skill = [], key, item, arr_staff = [];
                        item = {};
                        item.key = response.settingBlock == "tgo" ? block_list[i].value.serv_name : block_list[i].value.skill_name;
                        for (key in block_list[i].value.staff) {
                            arr_staff.push(
                                {
                                    "fio": block_list[i].value.staff[key],
                                    "confirm": block_list[i].value.confirm[key]
                                }
                            );
                        }
                        item.value = arr_staff;
                        staff.push(item);
                    }
                }
            }
            response.staff_list = staff;

            var tgo_check = [], skill_check = [];
            if(localStorage.getItem("tgo")) {
                let list = JSON.parse(localStorage.getItem("tgo"));
                for(let i=0; i<list.length; i++) {
                    if(list[i].check)
                        tgo_check.push(list[i].key);
                }
            }
            if(localStorage.getItem("skill")) {
                let list = JSON.parse(localStorage.getItem("skill"));
                for(let i=0; i<list.length; i++) {
                    if(list[i].check)
                        skill_check.push(list[i].key);
                }
            }

            var settings;
            var tgo = [], skill = [], key, item;
            for ( key in response.staffSettings.tgo) {
                item = {};
                item.key = key;
                item.value = response.staffSettings.tgo[key];
                item.check = tgo_check.includes(key);
                tgo.push(item);
            }
            for ( key in response.staffSettings.skill) {
                item = {};
                item.key = key;
                item.value = response.staffSettings.skill[key];
                item.check = skill_check.includes(key);
                skill.push(item);
            }

            localStorage.setItem("tgo", JSON.stringify(tgo));
            localStorage.setItem("skill", JSON.stringify(skill));

            let PV = response.info.PV;
            localStorage.setItem("direction", PV);


            settings = {
                "tgo": tgo,
                "skill": skill
            };
            response.staffSettings = settings;


            loader.hide();

            return response;
        }, function (response) {
            if (response && response.message) {
                self.errmsg = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });

    },
    view: function (ctrl) {
        return [
            m.component(HeaderMenuBlock, {
                time: ctrl.data().time,
                menu: ctrl.topMenu
            }),
            m("div[style='margin-top:0']", [
                VehicleNumberBlock(),
                m.component(flightMenuBlock, {
                    board: ctrl.data().board,
                    menu: ctrl.data().menu,
                    tasks: ctrl.data().tasks,
                    currentTask: ctrl.data().currentTask,
                    tab: 'info'
                })
            ]),
            m(".container[style='padding: 0 15px; padding-top: 10px;']", [

                m(".row[style='text-align: right; font-weight: bold;']", [
                    m("p.col-xs-7", ["Персонал"]),
                    m(".col-xs-5", [
                        m("button.btn[style='border-radius: 5px'][id='']", {
                            onclick: function () {
                                ModalContainerStaffSettings.open();
                            }
                        }, ["Настройки"])
                    ])
                ]),
                m("div[id='test']", [
                    print_staff(ctrl.data().staff_list, ctrl.data().info.PV, ctrl.data().settingBlock)
                ]),
                ModalContainerStaffSettings.init(ctrl.data().staffSettings)

            ]),


        ];
    }
};
